import { HttpErrorResponse } from '@angular/common/http';

export class ApiError {
  constructor(public type: ApiErrorType, public message: string, public extra: any, public helpLink: string) {
  }

  static fromResponse(errorResponse: HttpErrorResponse) {
    const err = this._parseError(errorResponse.error);
    return new ApiError(err.IdenediExceptionType, err.Message, err.ExtraInfo, err.HelpLink);
  }

  static _parseError(err: any) {
    try {
      return JSON.parse(err);
    } catch (error) {
      return err;
    }
  }
}

export enum ApiErrorType {
  InvalidUser = 'INVALID_USER',
  InvalidPassword = 'INVALID_PASSWORD',
  PhoneExists = 'PHONE_ALREADY_EXISTS',
  UserExists = 'USER_ALREADY_EXISTS',
  InvalidCode = 'INVALID_VERIFICATION_CODE',
  InvalidEmail = 'INVALID_EMAIL',
  PasswordNotStrong = 'PASSWORD_NOT_STRONG',
  RequirePasswordReset = 'REQUIRE_PASSWORD_RESET',
  TwoFA_REQUIRED = '2FA_REQUIRED'
}
